// extracted by mini-css-extract-plugin
export default {"tablehead":"TableCustomer_tablehead__sfYzI","custom-striped-table":"TableCustomer_custom-striped-table__QImJf"};